import { useQuery } from 'react-query';
import getTournament from '@api/getTournament';
export const FETCH_TOURNAMENT_QUERY_KEY = 'tournament';
const useGetTournament = (tournamentId, authenticated, enabled = true) => {
    return useQuery([FETCH_TOURNAMENT_QUERY_KEY, tournamentId, authenticated], () => getTournament(tournamentId), {
        enabled,
        staleTime: 1000 * 60 * 60, // 1 hour
    });
};
export default useGetTournament;
